import { CareAppListActionFactory } from './action-factory';
import { OrganisationFeedbackInterface } from '@careapp/angular-sdk';

export const Feedback = new CareAppListActionFactory<OrganisationFeedbackInterface>('feedback');
